export class SupplierDashboardBiddingSessionsStats {
	public numAllSessions: number;
	public numPinnedSessions: number;
	public numClosingSoonSessions: number;
	public numOpenToBidSessions: number;
	public numParticipatingSessions: number;
	public numNotParticipatedSessions: number;
	public numOptedOutSessions: number;
	public numClosedSessions: number;
	public numWonSessions: number;
	public numLostSessions: number;
	public numEndedSessions: number;

	constructor(supplierDashboardBiddingSessionsStats: SupplierDashboardBiddingSessionsStats) {
		Object.assign(this, supplierDashboardBiddingSessionsStats);
	}
}
